/**
 * お気に入り一覧ページ（page.wishlist）向け
 *
 * MultiLikes の customer_wishlist ブロックは「ブランドお気に入り」タブを
 * 店舗タブと同じ機能フラグ（app.metafields.config.feature_metaobject）で
 * 出し分けており、タブ単位で非表示にする設定が無い。
 * 本サイトではブランドお気に入りを提供しないため、テーマ側でタブごと取り除く。
 *
 * 注意: お気に入り商品が1件もない顧客は「商品」タブ自体が出力されず、
 * 「ブランド」が既定のアクティブタブになる。CSS で非表示にするだけだと
 * どのタブの中身も表示されない状態になるため、アプリ側の click ハンドラを
 * 使って正しく別タブへ切り替える。
 *
 * タイミング: アプリの wishlist.js は defer 付きで <head> 側（content_for_header）
 * に出力される。このスクリプトも defer で本文側に置くことで、
 * DOMContentLoaded のリスナー登録順が「アプリ→このスクリプト」になり、
 * アプリ側のタブ切替クリックリスナーが先に登録された状態で動作する。
 */
(function () {
  'use strict';

  var BRAND_TAB = 'multilikes_brand';

  document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('customer-wishlist');
    if (!container) return;

    var brandTab = container.querySelector('.customer-wishlist-tab[data-tab="' + BRAND_TAB + '"]');
    var brandContent = container.querySelector('.customer-wishlist-content[data-content="' + BRAND_TAB + '"]');
    if (!brandTab && !brandContent) return;

    var wasActive = !!(brandTab && brandTab.classList.contains('is-active'));

    if (brandTab) brandTab.remove();
    if (brandContent) brandContent.remove();

    if (wasActive) {
      var nextTab = container.querySelector('.customer-wishlist-tab');
      // アプリ側に既に付いているクリックリスナーに、タブ切替とお気に入り内容の
      // 初期化（fetch含む）をそのまま任せる。ここで class を手で付け替えるだけだと
      // アプリ側の初期化処理が呼ばれず、切替先タブの中身が空のままになる。
      if (nextTab) nextTab.click();
    }

    // ブランドタブを DOM から取り除いたことで、既存の
    // `.customer-wishlist-tabs-container:has(.customer-wishlist-tab:only-child)` が
    // 残り1タブの場合に正しく機能するはずだが、念のため直接も判定しておく。
    var tabsContainer = container.querySelector('.customer-wishlist-tabs-container');
    var remainingTabs = container.querySelectorAll('.customer-wishlist-tab');
    if (tabsContainer && remainingTabs.length <= 1) {
      tabsContainer.hidden = true;
    }
  });
})();
